export default __webpack_public_path__ + "9fd951236711b18a198f09405bcf737e.svg";